export type AppSession = {
  refresh_token: string;
  access_token: string;
  staff?: {
    userId: string;
    fullName: string;
  };
};

export const createStorage = <Type>(key: string) => ({
  getItem: () => {
    const sessionInfo: Type = JSON.parse(localStorage.getItem(key) || "null");
    return sessionInfo;
  },

  setItem: (payload: Partial<Type>) => {
    const sessionInfo: Type | null = JSON.parse(localStorage.getItem(key) || "null");

    const mergedData = sessionInfo
      ? {
          ...sessionInfo,
          ...payload,
        }
      : payload;

    try {
      localStorage.setItem(key, JSON.stringify(mergedData));
    } catch (err) {
      throw new Error((err as Error).message);
    }
  },

  removeItem: () => {
    localStorage.removeItem(key);
  },
});

export const appSession = createStorage<AppSession>("user");
